import { render, staticRenderFns } from "./speed.vue?vue&type=template&id=200b2e92&scoped=true"
import script from "./speed.vue?vue&type=script&lang=js"
export * from "./speed.vue?vue&type=script&lang=js"
import style0 from "./speed.vue?vue&type=style&index=0&id=200b2e92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b2e92",
  null
  
)

export default component.exports